// /* ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––

// 	video js - initial setting js

// 	해당 셋팅 공통 js로 정의를 해두고 실행 api에서 ready 콜백으로 호출
// 	별도 옵션 변경시엔 new 오브젝트 생성해서 변경 사용바랍니다!

// 	추후 빌드 셋팅 변경후 export 방식으로 변경!

// 	[ 로직 ]
// 	- 타임 포멧 변경 0:00:00
// 	- 컨트롤러 구조 변경
// 	- 제한 시간 셋팅
// 	- 스크롤 스크린 on play & paused
// 	- 스와퍼 play & paused
// 	- mute 클릭시 컨트롤러 활성 막기

// 	by 이재욱

//  –––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––– */
//  ;(function(doc, global, gs) {
// 	'use strict';

// 	var winTop = 0;
// 	var muteOn = true; // ios 전체 플레이어 볼률 컨트롤 테스트

// 	// 시간 포멧 변경 H:MM:SS - 남은 시간이 있을 경우만
// 	if (videojs) {
// 		videojs.getComponent('RemainingTimeDisplay').prototype.updateContent = function(){
// 			if ( this.player_.duration()) {
// 				var formattedTime = videojs.formatTime( this.player_.remainingTime(), 600 );
// 				this.contentEl_.innerHTML = formattedTime;
// 			}
// 		}
// 		videojs.getComponent('currentTimeDisplay').prototype.updateContent = function(){
// 			if ( this.player_.duration()) {
// 				var formattedTime = videojs.formatTime( this.player_.currentTime(), 600 );
// 				this.contentEl_.innerHTML = formattedTime;
// 			}
// 		}
// 		videojs.getComponent('durationDisplay').prototype.updateContent = function(){
// 			if ( this.player_.duration()) {
// 				var formattedTime = videojs.formatTime( this.player_.duration(), 600 );
// 				this.contentEl_.innerHTML = formattedTime;
// 			}
// 		}
// 	}
// 	// Setting
// 	var GsPayerSettings = {

// 		init: function(){

// 			if (!this) return;

// 			var self = this;
// 			this.scrollActive = true; // 스크롤 체크
// 			this.limit = this.options_.useLimit || false;
// 			this.multicheck = this.options_.multicheck;
// 			this.muteTouch = null;

// 			// console.log(this, this.isReady_ , this.hasStarted_  );

// 			if (!this.hasStarted_ )
// 				gs.vod.grouping( self );

// 			// 제한 시간 정지
// 			self.on('timeupdate', function() {
// 				if (self.limit && !self.paused()) {
// 					if (Math.floor(self.currentTime()) >= self.options_.limitTime) {
// 						self.el().classList.remove('active-cancel');
// 						self.el().classList.add('limit-play');
// 						self.limit = 'stop';
// 						self.pause();
// 					}
// 				}
// 			});

// 			// 재생 토글 이벤트 재설정
// 			if (self.controlBar.playToggle) {
// 				self.controlBar.playToggle.handleClick = function(){
// 					if ( !self.options_.autoplay && self.el().classList.contains('lte-notice')) {
// 						self.el().classList.add('lte-notice_on');
// 						return;
// 					}

// 					if (self.paused()) {
// 						if (self.el().classList.contains('limit-play')) {
// 							self.el().classList.remove('limit-play');
// 							self.currentTime(0);
// 							self.limit = true;
// 						}
// 						// 고민중!
// 						if (self.multicheck) {
// 							gs.vod.allPaused();
// 						}

// 						self.play();
// 						self.scrollActive = true;

// 					} else {
// 						self.pause();
// 						self.scrollActive = false;
// 					}
// 				}
// 			}

// 			if (!this.options_.scrollStop && !this.options_.dataCheck && self.el_) {

// 				window.addEventListener('scroll', gs.throttle(function(){
// 					if (self.el_) gs.vod.scroll( self );
// 				}, 200));

// 				// setTimeout(()=>{
// 				// 	gs.vod.scroll( self );
// 				// }, 200);

// 			}
// 		},
// 		// 테스트
// 		// playState: function( vod, status ){
// 		// 	let playPromise = vod.play();

// 		// 	if (playPromise !== undefined) {
// 		// 		playPromise
// 		// 		.then( _ => {
// 		// 			if (status == 'play') {
// 		// 				vod.play();
// 		// 			} else {
// 		// 				vod.pause();
// 		// 			}
// 		// 		})
// 		// 		.catch(error => {
// 		// 			console.log('@', error);
// 		// 		});
// 		// 	}
// 		// },

// 		// 스크롤 Play Fn - IntersectionObserver로 변경 고민중!
// 		scroll: function( vod ) {
//             if (!vod || !vod.el_) return;

//             if ( !vod.isFullscreen() && !vod.multicheck) {

//                 let playPromise = vod.play();

//                 if ( playPromise !== undefined) {
//                     playPromise.then(() => {
//                         if ( isOnScreen(vod.el(), -120 )) {
//                             if (vod.paused() && vod.scrollActive && vod.limit != 'stop') {
//                                 vod.play();
//                             }
//                         } else {
//                             if (!vod.paused()) {
//                                 vod.el().classList.remove('active-cancel');
//                                 vod.pause();
//                             }
//                         }
//                     })
//                     .catch(error => {
//                         console.log('@', error);
//                     });
//                 }

// 			}
// 		},
// 		// scroll: function( vod ) {
// 		// 	if (!vod || !vod.el_) return;

// 		// 	if ( !vod.isFullscreen() && !vod.multicheck) {
// 		// 			// IntersectionObserver로 변경 고민중!
// 		// 		if ( isOnScreen(vod.el(), -120 )) {
// 		// 			if (vod.paused() && vod.scrollActive && vod.limit != 'stop') {
// 		// 				// console.log('@PLAY', vod.id_);
// 		// 				vod.play();
// 		// 				// gs.vod.playState( vod, 'play' );
// 		// 			}
// 		// 		} else {
// 		// 			if (vod && !vod.paused()) {
// 		// 				vod.el().classList.remove('active-cancel');
// 		// 				// gs.vod.playState( vod, 'pause' );
// 		// 				//  console.log('@STOP',  vod.children_[0]);
// 		// 				let playPromise = vod.play();

// 		// 				if ( playPromise !== undefined) {
// 		// 					playPromise.then(() => {
// 		// 						vod.pause();
// 		// 					})
// 		// 					.catch(error => {
// 		// 						console.log('@', error);
// 		// 					});
// 		// 				}
// 		// 			}
// 		// 		}
// 		// 	}
// 		// },

// 		// 모든 플레이어 정지
// 		allPaused: function() {
// 			doc.querySelectorAll('video').forEach(function(vod){
// 				if (!vod.paused) vod.pause();
// 			});
// //			videojs.getAllPlayers('video').forEach(function(el){
// //				 if (!el.paused()) el.pause();
// //			});
// 		},

// 		// 컨트롤러 그룹핑 Fn
// 		grouping: function( vod ) {

// 			if (!vod) return;

// 			var ctrls = vod.controlBar;

// 			if (!ctrls.children_.length)
// 				ctrls.el_.classList.add('hidden');

// 			// 컨트롤 버튼 그룹핑 division 생성
// 			//appendEl( ctrls.el(), ['ctrl-play', 'ctrl-wrap', 'ctrl-flex', 'ctrl-aside']);
// 			var group = '<div class="ctrl-play"></div><div class="ctrl-wrap"><div class="ctrl-progress"></div><div class="ctrl-aside"></div></div>';
// 			var databox = '<div class="data-warning-wrap"><p class="data-warning-text">3G/LTE 등으로 접속 시<br>데이터 통화료가 발생할 수 있습니다</p><div class="button-wrapper"><button type="button" class="btn-agree-cancel">취소</button><button type="button" class="btn-agree-confirm">확인</button></div></div>';
// 			var goLink = vod.el().querySelector('video').getAttribute('go-url');
// 			var dirLink = vod.el().querySelector('video').getAttribute('direct-link');

// 			ctrls.el().insertAdjacentHTML('beforeend', group);

// 			var components = [
// 				{'ctrl-play' : (vod.options_.dataCheck) ? databox : ''},
// 				{'ctrl-play' : (vod.options_.useLimit) ? '<button class="keep-play" type="button"><span>동영상 더보기</span></button>' : ''},
// 				{'ctrl-play' : (ctrls.fullscreenToggle) ? '<button class="close-fullscreen" type="button"><span>전체화면 닫기</span></button>' : ''}, // 레이어 x 닫기
// 				{'ctrl-play' : (ctrls.playToggle) ? ctrls.playToggle.el_ : ''},
// 				{'ctrl-play' : (goLink) ? '<a class="go-link" href="'+goLink+'"><span>자세히 보기</span></a>' : ''},
// 				{'ctrl-play' : (ctrls.remainingTimeDisplay) ? ctrls.remainingTimeDisplay.el_ : ''},
// 				{'ctrl-progress' : (ctrls.currentTimeDisplay) ? ctrls.currentTimeDisplay.el_ : ''},
// 				{'ctrl-progress' : (ctrls.progressControl) ? ctrls.progressControl.el_ : ''},
// 				{'ctrl-progress' : (ctrls.durationDisplay) ? ctrls.durationDisplay.el_  : ''},
// 				{'ctrl-aside' : (ctrls.volumePanel) ? ctrls.volumePanel.el_ : ''},
// 				{'ctrl-aside' : (ctrls.fullscreenToggle) ? ctrls.fullscreenToggle.el_ : ''},
// 			];

// 			if (!ctrls.playToggle && !ctrls.fullscreenToggle && !ctrls.remainingTimeDisplay && !vod.options_.useLimit) {
// 				vod.el().querySelector('.ctrl-play').hidden = true;
// 			}
// 			if (dirLink &&  dirLink.charAt(0) != '#') {
// 				vod.controlBar.el().insertAdjacentHTML('afterbegin','<a class="dir-link" href="'+dirLink+'"><span class="blind">바로가기</span></a>');
// 			}
// 			components.forEach(function(obj) {
// //				Object.entries(obj).forEach(function([ key, comp ]) {
// //					if (comp) $(vod.el()).find('.'+key).append(comp); // 추후 수정!
// //				});
// 				//IE Object.entries 지원 안됨 - 대응
// 				Object.keys(obj).map(function(i) {
// 					if (obj[i]) $(vod.el()).find('.'+Object.keys(obj)).append(obj[i]); // 추후수정!
// 				});

// 			});

// 			if (vod.options_.dataCheck) vod.el().classList.add('lte-notice');
// 			vod.el().classList.add('ready');
// 			this.addEvent( vod );
// 		},

// 		// 신규 콤포넌트 이벤트
// 		addEvent: function( vod ) {

// 			// muteToggle 터치 활성 막기
// 			if( vod.controlBar.volumePanel ) {
// 				vod.on('volumechange', function(e){
// 					var self = this;
// 					clearTimeout(this.muteTouch);

// 					if (!vod.paused()) vod.el().classList.add('active-cancel');

// 					this.muteTouch = setTimeout(function(){
// 						vod.el().classList.remove('active-cancel');
// 						self.muteTouch = null;
// 					}, 3000);

// 				});
// 			}

// 			// LTE 데이터 과금 안내 - 확인
// 			if ( vod.options_.dataCheck ) {
// 				vod.el().querySelector('.btn-agree-confirm').addEventListener('click', function(){

// 					doc.querySelectorAll('.lte-notice').forEach(function(el){
// 						el.classList.remove('lte-notice', 'lte-notice_on');
// 					});
// 					vod.el().classList.remove('lte-notice_on');
// 					vod.play();
// 				});
// 				vod.el().querySelector('.btn-agree-cancel').addEventListener('click', function(){
// 					vod.el().classList.remove('lte-notice_on');
// 				});

// 			}

// 			// 동영상 이어보기
// 			if ( vod.options_.useLimit ) {
// 				vod.el().querySelector('.keep-play').addEventListener('click', function(){
// 					if (vod.controlBar.fullscreenToggle && !vod.isFullscreen()) vod.requestFullscreen();
// 					vod.limit = false;
// 					vod.el().classList.remove('limit-play');
// 					vod.play();
// 				});
// 			}
// 			// 풀 스크린 관련
// 			if ( vod.controlBar.fullscreenToggle ) {
// 				// 전체화면 x 닫기
// 				vod.el().querySelector('.close-fullscreen').addEventListener('click', function(){
// 					vod.exitFullscreen();
// 				});

// 				// ios scroll top 체크
// 				vod.on('fullscreenchange', function(e){
// 					if (videojs.browser.IS_IOS) {
// 						if ( this.isFullscreen()) {
// 							winTop = window.scrollY;
// 						} else {
// 							setTimeout(function(){
// 								window.scrollTo(0, winTop);
// 							}, 5);
// 						}
// 					}
// 				});
// 			}
// 		},

// 		// swiper change Fn
// 		swiperChange: function( swiper ) {

// 			var currentVod = swiper.slides[swiper.activeIndex].querySelector('video');
// 			swiper.slides.forEach(function(other, index){

// 				var otherVod = videojs.getPlayer(other.querySelector('video'));

// 				setTimeout(function(){
// 					if (otherVod && swiper.activeIndex != index) {
// 						otherVod.ready(function(){
// 							otherVod.multicheck = true;
// 							if (!this.paused()) {
// 								this.pause();
// 								// gs.vod.playState( this, 'pause' );
// 							}
// 						});
// 					}
// 				}, 15);
// 			});
// 			if (currentVod) {

// 				setTimeout(function(){

// 					videojs.getPlayer( currentVod ).ready(function(){
// 						this.multicheck = false;
// 						if (this.paused()){
// 							if( this.el().classList.contains('lte-notice')) {
// 								this.el().classList.add('lte-notice_on');
// 							} else {
// 								// swiper.autoplay.stop();
// 								this.play();
// 								// gs.vod.playState( this, 'play' );
// 							}
// 						}
// 					});
// 				}, 100);
// 			}
// 		},

// 		// swiper 멀티 동영상 테스트 ( 급조 ) 2024-08-30
// 		multiPlayerChange: function( swiper ) {

// 			// console.log('@end');
// 			swiper.slides.forEach((el, index) => {
// 				let vod = el.querySelector('video');
// 				if (vod && !vod.paused) vod.pause();

// 				// var playPromise = vod.play();

// 				// if (playPromise !== undefined) {
// 				// 	playPromise.then(_ => {
// 				// 		vod.pause();
// 				// 	})
// 				// 	.catch(error => {
// 				// 		console('@', error);
// 				// 	});
// 				// }
// 				// console.log(el);
// 			});

// 			// 활성화된 슬라이드
// 			swiper.visibleSlides.forEach((el, index ) => {
// 				let vod = el.querySelector('video'), movieEnd ='';
// 				if (vod) {
// 					// auto 롤링 정지
// 					clearTimeout(movieEnd);
// 					if (el == swiper.slides[swiper.activeIndex] ) {
// 						// console.log(swiper.autoplay.running);
// 						swiper.autoplay.stop();
// 						vod.currentTime = 0;
// 					}

// 					movieEnd = setTimeout(()=>{
// 						// vod.play();
// 						// 이벤트 중첩 제거 - 임시

// 						var playPromise = vod.play();

// 						if (playPromise !== undefined) {
// 							playPromise.then(_ => {
// 								vod.play();
// 								// 이벤트 중첩 제거 - 임시
// 								$(vod).unbind('.plrEnd').on('ended.plrEnd', function(){
// 										if (el == swiper.slides[swiper.activeIndex]) {
// 											if (swiper.slides.length >1) {
// 												swiper.slideNext();
// 												swiper.autoplay.start();
// 											} else {
// 												vod.play();
// 											}
// 										} else {
// 											vod.play(); // 멀티 노출 시 미리 끝난 영상은 반복 재생
// 										}
// 									});
// 							})
// 							.catch(error => {
// 								console.log('@', error);
// 							});
// 						}
// 					}, 150);
// 				} else {
// 					if (!swiper.autoplay.running &&
// 						swiper.params.autoplay.enabled &&
// 						el == swiper.slides[swiper.activeIndex])
// 					{
// 						swiper.autoplay.start();
// 					}
// 				}
// 			});
// 		},

// 	};

// 	// 프로토타입 new 선언!! 따로 변경할 경우 사용!!
// 	gs.playerSetting = function(){}
// 	gs.playerSetting.prototype = GsPayerSettings;
// 	gs.playerSetting.prototype.constructor = gs.playerSetting;
// 	// 사용예시 : var ex = new gs.playerSetting();

// 	gs.vod = GsPayerSettings;

// // 테스트를 위한 배열
// let testArray = [1, 2, 3];

// let testAert = new gs.alert({
//     type: 'confirm',
// });

// function awaitTest() {
//     return new Promise((resolve) => {
//         // 타겟 그냥 찾아서 실행 이벤트
//         testAert.el.querySelector('.ok').addEventListener('click', () => {
//             resolve();
//         });
//     });
// }

// async function waitForContinueTest() {
//     if (testArray[0] === 1) {
//         testAert.render('step 1번');
//         console.log('조건 1번');
//         await awaitTest();
//     }
//     if (testArray[1] === 2) {
//         testAert.render('step 2번');
//         console.log('조건 2번');
//         await awaitTest();
//     }
//     if (testArray[2] === 3) {
//         testAert.render('step 3번');
//         console.log('조건 3번');
//         await awaitTest();
//     }
// }

// waitForContinueTest();

// })(document, window, window.gs = window.gs || {});
